import React from 'react';
import Routers from 'src/components/routers';
import 'antd/dist/antd.css';
import { disableReactDevtools } from 'src/components/app/disableReactDevtools';

// Disable React Devtools in production, if exists.
if (process.env.REACT_APP_ENV === 'prod') {
    disableReactDevtools();
}

/**
 * Renders main application
 */
function App() {
    return (
        <div className="App">
            <Routers />
        </div>
    );
}

export default App;
